import * as uuid from "uuid";

export class Caller {
  Events
  _registre = {}

  /**
   *
   * @param Functions {object}
   * @param Events {object}
   * @param EventsMapping {Map} Not implemented
   */
  constructor(Functions, Events, EventsMapping) {
    this.Events = Events || {};
    Object.keys(Functions).forEach(fn => {
      this[fn] = Functions[fn];
      // TODO Add Mapping
    });
  }

  Register(eventName, callBack) {
    return _registerCB(this._registre, eventName, callBack)
  }

  Unregister(id) {
    return _unregisterCB(this._registre, id)
  }
}

function _registerCB(registre, eventName, cb) {
  const id = uuid.v4();
  registre[eventName] = {...registre[eventName], [id]: cb};
  return eventName + "." + id;
}

function _triggerEvent(registre, eventName) {
  const EventCallBacks = registre[eventName] || {};
  Object.keys(EventCallBacks).forEach(id => EventCallBacks[id]?.());
}

function _unregisterCB(registre, id) {
  const [eventName, key] = id.split(".");
  delete registre[eventName][key];
}